var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "no-auto-height": "",
          "auto-scroll": false,
          "row-key": "id",
          "reset-data": _vm.resetDataFn,
        },
        on: {
          handleTableDataChange: _vm.handleTableDataChange,
          handleSelectionChange: _vm.handleSelectionChange,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("orderNewPatch.Product"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessThirdOrderAdd.form.SKU"),
                    prop: "standardSkuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.SPU"),
                    prop: "batchNumList",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": scope.row.batchNumList,
                              placeholder: _vm.$t(
                                "OrdinaryOrderMix.OrderItemTable.SPU"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: scope.row.spuCode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "spuCode", $$v)
                              },
                              expression: "scope.row.spuCode",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessThirdOrderAdd.form.Quantity"),
                    prop: "quantity",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-input-number", {
                            staticClass: "full-width",
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              min: 0,
                              precision: 0,
                              controls: false,
                            },
                            on: {
                              blur: function ($event) {
                                return _vm.onBlurQuantity(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.quantity,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "quantity", $$v)
                              },
                              expression: "scope.row.quantity",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessBatchInventoryQuery.table.usableNum2"
                    ),
                    prop: "usableNum",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.batchNumList &&
                          scope.row.batchNumList.length > 0
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.batchNumList.bjGet(
                                        scope.row.spuCode,
                                        "value",
                                        "usableNum"
                                      )
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.isTrue
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.$t("BusinessThirdOrderAdd.form.The"),
                        prop: "thirdDiscountAmount",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("BjInputMoney", {
                                  attrs: {
                                    max:
                                      scope.row.outerSingleSaleAmount *
                                        scope.row.quantity -
                                      scope.row.businessDiscountAmount,
                                  },
                                  model: {
                                    value: scope.row.thirdDiscountAmount,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "thirdDiscountAmount",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.thirdDiscountAmount",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2794509036
                      ),
                    })
                  : _vm._e(),
                !_vm.isTrue && _vm.isShow
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.$t(
                          "BusinessOrderAuditComSkuList.transPrice"
                        ),
                        prop: "freight",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("BjInputMoney", {
                                  model: {
                                    value: scope.row.freight,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "freight", $$v)
                                    },
                                    expression: "scope.row.freight",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2156151126
                      ),
                    })
                  : _vm._e(),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("BusinessThirdOrderAdd.form.Operation"),
                    align: "center",
                    fixed: "right",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("delText")))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }